/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
 
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      children: [
        // =============================================================================
        // Theme Routes 
        // =============================================================================
        {
          path: '/',
          name: 'Dashboard',
          component: () => import('./views/Home.vue'),
        },

        {
          path: '/dashboard/:subject',
          name: 'branchUser',
          component: () => import('./views/dashboard/main.vue'),
          meta: {
            rule: 'editor',
          }
        },

        {
          path: '/view/:endPoint',
          name: 'view',
          component: () => import('./views/basicTable/table.vue')
        },


        //SETTINGS link====================================================================================
        {
          path: '/settings',
          name: 'settings',
          component: () => import('./views/settings/settings.vue')
        },
        {
          path: '/edit_settings/:id',
          name: 'edit_settings',
          component: () => import('./views/settings/edit_settings.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'Purchase Requisition', active: true },
            ],
          },
        },
        //--------------------------------------------------------------------------------------------------



        //REPORT==================================================================================
        {
          path: '/report/:endPoint',
          name: 'report',
          component: () => import('./views/report/main_report.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'report', active: true },
            ],
            payload: [
              { data: 'this is the data' }
            ]
          },
        },
        //report----------------------------------------------------------------------------------

        //ADVANCE FORM List========================================================================
        {
          path: '/form/:subject/:key',
          name: 'formList',
          component: () => import('./views/advance_form/form_list.vue'),
          meta: {
            breadcrumb: [
              { title: 'Home', url: '/' },
              { title: 'List', active: true },
            ],
            payload: [
              { data: 'this is the data' }
            ]
          },
        },
        //--------------------------------------------------------------------------------------------

      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/approval/:token/:email',
          name: 'approval',
          component: () => import('@/views/pages/approval.vue')
        },
        {
          path: '/notFound',
          name: 'not-found',
          component: () => import('@/views/pages/tokenNotFound.vue')
        },
        {
          path: '/approved',
          name: 'record-approved',
          component: () => import('@/views/pages/tokenApproved.vue')
        },
        {
          path: '/rejected',
          name: 'record-rejected',
          component: () => import('@/views/pages/tokenRejected.vue')
        },
        {
          path: '/pages/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/pages/PO',
          name: 'PO',
          component: () => import('./components/aron/dataViews/purchase_order_print.vue'),
        },
        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/register',
          name: 'page-register',
          component: () => import('@/views/pages/register/Register.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/login',
          name: 'page-login',
          component: () => import('@/views/pages/Login.vue'),
          meta: {
            rule: 'editor'
          }
        },

        {
          path: '/passwordRecovery/:token',
          name: 'page-login',
          component: () => import('@/views/pages/passwordRecovery.vue'),
          meta: {
            rule: 'editor'
          }
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
